var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "DIV",
        { staticClass: "badge border" },
        [
          _c("ItpIcon", { attrs: { icon: "material-symbols:repeat-rounded" } }),
          _vm._v(" "),
          _c("ItpText", {
            attrs: { text: _vm.billingFrequencyOptions[_vm.value].name }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }